import React, { useRef, useState, useEffect } from "react";
// import "./trending.scss";
import "./listing.scss";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import { Box, Container, Grid } from "@mui/material";
import SEO from "../../seo/SEO";
import { createPortal } from "react-dom";
import { Modal } from "bootstrap";
function TrendingPageNew() {
    useEffect(() => {
        const handleScroll = () => {
            clearTimeout(hoverTimer.current);

            setPopupData(null);
            setPopupPosition(null);
        };

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    const [popupData, setPopupData] = useState(null);
    const [popupPosition, setPopupPosition] = useState(null);

    const hoverTimer = useRef(null);

    const POPUP_WIDTH = 360;

    const handleMouseEnter = (item, e) => {
        clearTimeout(hoverTimer.current);

        const rect = e.currentTarget.getBoundingClientRect();

        let left = rect.left + rect.width / 2;

        // Left edge
        if (left - POPUP_WIDTH / 2 < 20) {
            left = POPUP_WIDTH / 2 + 20;
        }

        // Right edge
        if (left + POPUP_WIDTH / 2 > window.innerWidth - 20) {
            left = window.innerWidth - POPUP_WIDTH / 2 - 20;
        }

        hoverTimer.current = setTimeout(() => {
            setPopupData(item);

            setPopupPosition({
                top: rect.top - 20,
                left,
            });
        }, 1000);
    };

    const handleMouseLeave = () => {
        clearTimeout(hoverTimer.current);

        hoverTimer.current = setTimeout(() => {
            setPopupData(null);
            setPopupPosition(null);
        }, 150);
    };

    const [videoItem, setVideoItem] = useState(null);

    const steps = [
        {
            id: "01",
            icon: "fa fa-mobile",
            title: "STEP ",
            description: "Open the Mandirwiki app and select the video you would like to watch.",
        },
        {
            id: "02",
            icon: "fa fa-mobile",
            title: "STEP",
            description: "Place your phone inside the VR headset.",
        },
        {
            id: "03",
            icon: "fa fa-headphones",
            title: "STEP",
            description:
                "If the image appears blurry, use the adjustment wheel on the VR headset to adjust the lenses until the view is clear.",
        },
    ];
    const vrShowData = [
        { title: "DWARKA BENEATH THE SEA", image: "/assets/trending/sea.webp" },
        { title: "VARANASI AFTER SUNSET", image: "/assets/trending/varanasi.webp" },
        { title: "KASHI", image: "/assets/trending/varanasi.webp" },
        { title: "MANIKARNIKA", image: "/assets/trending/manikarna.webp" },
    ];
    const dData = [
        { title: "THE LAST MOMENTS OF LORD KRISHNA", image: "/assets/trending/krishna.webp" },
        { title: "JAGANNATH PURI", image: "/assets/trending/jaganath-puri.webp" },
        { title: "KEDARNATH", image: "/assets/trending/kedarnath2.webp" },
        { title: "BHIM SHILA", image: "/assets/trending/bhimshila.webp" },
        { title: "DEOGHAR", image: "/assets/trending/deoghar.webp" },
        { title: "VAISHNO DEVI", image: "/assets/trending/vaishno-devi.webp" },
    ];
    const trendingData = [
        { title: "AYODHYA MANDIR", image: "/assets/trending/somnath.webp", video: "/assets/trending/vr-video.mp4" },
        { title: "DWARKADHISH", image: "/assets/trending/mallikarjuna.webp", video: "/assets/trending/vr-video.mp4" },
        { title: "KEDARNATH", image: "/assets/trending/kedarnath.webp", video: "/assets/trending/vr-video.mp4" },
        { title: "BANARAS", image: "/assets/trending/somnath.webp", video: "/assets/trending/vr-video.mp4" },
        { title: "THE LAST MOMENTS OF LORD KRISHNA", image: "/assets/trending/krishna.webp" },
        { title: "JAGANNATH PURI", image: "/assets/trending/jaganath-puri.webp" },
    ];
    const JyotirlingasData = [
        { title: "Somnath Temple", image: "/assets/trending/somnath.webp" },
        { title: "Mallikarjuna Temple", image: "/assets/trending/mallikarjuna.webp" },
        { title: "Mahakaleshwar Temple", image: "/assets/trending/mahakaleshwar.webp" },
        { title: "Omkareshwar Temple", image: "/assets/trending/omkareshwar.webp" },
        { title: "Bhimashankar Temple", image: "/assets/trending/bhimashankar.webp" },
        { title: "Baidyanath Temple", image: "/assets/trending/baidyanath.webp" },
    ];
    const chardhamData = [
        { title: "YAMUNOTRI", image: "/assets/trending/yamunotri.webp" },
        { title: "GANGOTRI", image: "/assets/trending/gangotri.webp" },
        { title: "KEDARNATH", image: "/assets/trending/kedarnath.webp" },
        { title: "BADRINATH", image: "/assets/trending/badrinath.webp" },
    ];
    const chotaChardhamData = [
        { title: "BADRINATH", image: "/assets/trending/badrinath.webp" },
        { title: "RAMESHWARAM", image: "/assets/trending/rameshwaram.webp" },
        { title: "DWARKA", image: "/assets/trending/dwarka.webp" },
        { title: "JAGANNATH", image: "/assets/trending/jaganath-puri.webp" },
    ];
    const deviTempleData = [
        { title: "Bhadrakali Temple", image: "/assets/trending/bhadrakali-temple.webp" },
        { title: "Maa Taratarini Temple", image: "/assets/trending/maa-taratarini.webp" },
        { title: "Vimala Temple", image: "/assets/trending/vimala.webp" },
        { title: "Kamakhya Temple", image: "/assets/trending/kamakhya.webp" },
        { title: "Kalighat Kali Temple", image: "/assets/trending/kalighat-kali.webp" },
        { title: "Jwalaji Temple", image: "/assets/trending/jwalaji-temple.webp" },
    ];
    const continueWatchingData = [
        { id: 1, title: "Nageshwar", image: "/assets/trending/demo-9.webp" },
        { id: 2, title: "Rameshwaram", image: "/assets/trending/demo-10.webp" },
        { id: 3, title: "Grishneshwar", image: "/assets/trending/demo-11.webp" },
        { id: 4, title: "Omkareshwar", image: "/assets/trending/demo-12.webp" },
    ];
    const sections = [
        {
            title: "Trending VR Shows",
            data: trendingData,
        },
        {
            title: "360 VR Shows",
            data: vrShowData,
        },
        {
            title: "180 VR Experience",
            data: dData,
        },
        {
            title: "12 Jyotirlingas",
            data: JyotirlingasData,
        },
        {
            title: "Chota Char Dham Yatra",
            data: chotaChardhamData,
        },
        {
            title: "Char Dham Yatra",
            data: chardhamData,
        },
        {
            title: "Shakti Peethas & Devi Temples",
            data: deviTempleData,
        },
    ];
    return (
        <>
            <SEO pageKey="vrDarshan" />
            <Box className="trendingPage newPage">
                <img src="/assets/banner/trending-page/demo-banner.png" className="img-fluid w-100" alt="" />
                <Container maxWidth="lg">
                    <Grid container spacing={2} justifyContent="left" alignItems="center">
                        <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}>
                            <Box className="VrBannerText">
                                <span className="virtualTab">Featured Darshan</span>
                                <div>
                                    <h1 className="mt-4 w-100">KASHI VISHWANATH</h1>
                                    <p>
                                        Walk the ancient ghats of Varanasi at dawn. A cinematic journey into the eternal
                                        city of light, its aartis, alleys, and the temple at its beating heart.
                                    </p>
                                    <div className="d-flex gap-3 bannerButton justify-content-center">
                                        <Box className="text-center mt-lg-3">
                                            <a
                                                href="#threeSteps"
                                                className="btn btn-warning bg-white border-0 text-dark"
                                            >
                                                <i className="fa fa-arrow-right me-1 text-dark"></i>More Info{" "}
                                            </a>
                                        </Box>
                                    </div>
                                </div>
                            </Box>
                        </Grid>
                    </Grid>
                </Container>
            </Box>
            <section className="darkTheme newDarkTheme">
                <Box className="trendingSection">
                    <Container maxWidth={false}>
                        {sections.map((section, index) => (
                            <Grid container alignItems="stretch" key={index}>
                                <Grid size={12}>
                                    <Grid container alignItems="stretch">
                                        <Grid size={{ xl: 6, lg: 6, md: 6, sm: 6, xs: 12 }}>
                                            <div className="vrHeading">
                                                <h2 className="text-start text-white mb-0">{section.title}</h2>
                                            </div>
                                        </Grid>

                                        <Grid size={{ xl: 6, lg: 6, md: 6, sm: 6, xs: 12 }}></Grid>
                                    </Grid>
                                </Grid>

                                <Grid size={12}>
                                    <Swiper
                                        className="swiperCitySlider"
                                        modules={[Navigation, Pagination, Autoplay]}
                                        spaceBetween={20}
                                        slidesPerView={4}
                                        autoplay={{
                                            delay: 3000,
                                            disableOnInteraction: false,
                                        }}
                                        breakpoints={{
                                            0: {
                                                slidesPerView: 2,
                                            },
                                            576: {
                                                slidesPerView: 3,
                                            },
                                            768: {
                                                slidesPerView: 3,
                                            },
                                            1200: {
                                                slidesPerView: 6,
                                            },
                                        }}
                                    >
                                        {section.data.map((item, i) => (
                                            <SwiperSlide key={item.id || i}>
                                                <div
                                                    className="netflixCard"
                                                    onMouseEnter={(e) => handleMouseEnter(item, e)}
                                                    onMouseLeave={handleMouseLeave}
                                                    onClick={() => {
                                                        clearTimeout(hoverTimer.current);

                                                        setVideoItem(item);
                                                        setPopupData(null);
                                                        setPopupPosition(null);

                                                        const modalElement = document.getElementById("videoModal");

                                                        if (modalElement) {
                                                            const modal = Modal.getOrCreateInstance(modalElement);
                                                            modal.show();
                                                        }
                                                    }}
                                                >
                                                    <div className="cardPoster">
                                                        <img src={item.image} alt={item.title} />
                                                    </div>
                                                </div>
                                            </SwiperSlide>
                                        ))}
                                    </Swiper>
                                </Grid>
                            </Grid>
                        ))}
                        <Box className="ritualStepsSection" id="threeSteps">
                            <Container maxWidth="lg">
                                <Grid container spacing={4} alignItems="center">
                                    <Grid size={{ xl: 5, lg: 5, md: 5, sm: 12, xs: 12 }}>
                                        <Box className="stepsLeft">
                                            <span className="subTitle text-white">THE RITUAL</span>
                                            <h2>
                                                THREE STEPS TO
                                                <br />
                                                YOUR DARSHAN.
                                            </h2>
                                            <p className="text-white">
                                                No headset? No problem. Each experience is built to be felt on any
                                                device, then deepened in full VR when you're ready.
                                            </p>
                                        </Box>
                                    </Grid>
                                    <Grid size={{ xl: 7, lg: 7, md: 7, sm: 12, xs: 12 }}>
                                        <Box className="stepsRight">
                                            {steps.map((item, index) => (
                                                <Box className="stepCard" key={index}>
                                                    <div className="iconBox">
                                                        <i className={item.icon}></i>
                                                    </div>
                                                    <div className="content">
                                                        <span>{item.id}</span>
                                                        <h4>{item.title}</h4>
                                                        <p>{item.description}</p>
                                                    </div>
                                                </Box>
                                            ))}
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Container>
                        </Box>
                    </Container>
                </Box>
            </section>

            {popupData &&
                popupPosition &&
                createPortal(
                    <div
                        className="hoverPopup"
                        style={{
                            position: "fixed",
                            top: popupPosition.top,
                            left: popupPosition.left,
                            transform: "translateX(-50%)",
                            zIndex: 999999,
                        }}
                        onMouseEnter={() => clearTimeout(hoverTimer.current)}
                        onMouseLeave={handleMouseLeave}
                    >
                        <div className="popupBanner">
                            <img src={popupData.image} alt={popupData.title} />
                        </div>

                        <div className="popupContent">
                            <div className="popupButtons">
                                <button
                                    className="playBtn"
                                    data-bs-toggle="modal"
                                    data-bs-target="#videoModal"
                                    onClick={() => {
                                        clearTimeout(hoverTimer.current);
                                        setVideoItem(popupData);
                                        setPopupData(null);
                                        setPopupPosition(null);
                                    }}
                                >
                                    <i className="fa fa-play"></i>
                                </button>

                                <button className="iconBtn">
                                    <i className="fa fa-plus"></i>
                                </button>

                                <button className="iconBtn">
                                    <i className="fa fa-thumbs-o-up"></i>
                                </button>

                                <button className="iconBtn ms-auto">
                                    <i className="fa fa-chevron-down"></i>
                                </button>
                            </div>

                            <div className="movieMeta">
                                <span className="match">98% Match</span>
                                <span className="age">U/A 13+</span>
                                <span>1 Season</span>
                                <span className="quality">HD</span>
                            </div>

                            <h4>{popupData.title}</h4>

                            <p>Experience this temple in immersive VR.</p>
                        </div>
                    </div>,
                    document.body
                )}

            <div
                className="modal fade"
                id="videoModal"
                tabIndex="-1"
                data-bs-backdrop="static"
                data-bs-keyboard="false"
            >
                <div className="modal-dialog modal-fullscreen">
                    <div className="modal-content bg-black">
                        <button
                            type="button"
                            className="btn-close btn-close-white position-absolute top-0 end-0 m-3"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            onClick={() => setVideoItem(null)}
                        >
                            <span className="text-white">&times;</span>
                        </button>

                        <div className="modal-body p-0 overflow-y-hidden">
                            <div className="videoOverlay">
                                <h2>{videoItem?.title}</h2>
                                <p>{videoItem?.description}</p>
                            </div>
                            <video key={videoItem?.video} controls autoPlay className="w-100 h-100">
                                <source src={videoItem?.video} type="video/mp4" />
                                Your browser does not support the video tag.
                            </video>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
export default TrendingPageNew;
